import React, { Component } from 'react'
import { observer } from 'mobx-react'

import Action from '@components/Action'
import Download from '@components/Icon/Download'
import { tokenStorage } from '@atheneum/api/dist/lib'

class Actions extends Component {
  exportToExcel = () => {
    const token = tokenStorage.get()
    const exportUrl = `/api/project/projects-pipeline?export=projects&token=${token}`
    window.open(exportUrl)
  }

  render() {
    return (
      <ul className="actions right-list">
        <li className="action" onClick={this.exportToExcel}>
          <Action>
            <Download />
            <span>Export</span>
          </Action>
        </li>
      </ul>
    )
  }
}

export default observer(Actions)
